import type { Breadcrumb, ErrorEvent } from '@sentry/react';

// Ces liens portent un JWT qui ouvre une session ou fixe un mot de passe : il ne doit pas sortir vers Sentry.
const TOKEN_IN_PATH = /(\/(?:recover-password|set-password|validate-employee)\/)[^/?#\s]+/g;

const FILTERED = '[Filtered]';

export function redactUrlTokens(value: string): string {
    return value.replace(TOKEN_IN_PATH, `$1${FILTERED}`);
}

function redactStringValues<T extends Record<string, unknown>>(record: T): T {
    return Object.fromEntries(
        Object.entries(record).map(([key, value]) => [key, typeof value === 'string' ? redactUrlTokens(value) : value]),
    ) as T;
}

function redactBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
    return {
        ...breadcrumb,
        ...(breadcrumb.message ? { message: redactUrlTokens(breadcrumb.message) } : {}),
        ...(breadcrumb.data ? { data: redactStringValues(breadcrumb.data) } : {}),
    };
}

export function redactTokensFromEvent(event: ErrorEvent): ErrorEvent {
    const { request, breadcrumbs } = event;

    return {
        ...event,
        ...(request
            ? {
                  request: {
                      ...request,
                      ...(request.url ? { url: redactUrlTokens(request.url) } : {}),
                      ...(request.headers ? { headers: redactStringValues(request.headers) } : {}),
                  },
              }
            : {}),
        ...(breadcrumbs ? { breadcrumbs: breadcrumbs.map(redactBreadcrumb) } : {}),
    };
}
